module.exports = __webpack_public_path__ + "static/media/plus.e731e34e.svg";